import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M61.3001 1.84009V1.81006C61.0501 1.81006 60.8101 1.82008 60.5501 1.83008C60.3001 1.83008 60.0601 1.81006 59.8001 1.81006V1.84009C15.9301 2.55009 -2.7199 34.1801 2.9001 63.8101C8.5801 93.7801 44.9401 98.8201 44.9401 98.8201H76.1401C76.1401 98.8201 112.5 93.7801 118.18 63.8101C123.82 34.1901 105.17 2.55009 61.3001 1.84009Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
